<app-background-card title="Tokens" titleTestId="token-list-header" testId="token-list-card">
  @if (loading()) {
    <app-loading />
  } @else {
    <div class="flex gap-3 justify-end mb-4">
      <p-select
        [options]="scopeOptions"
        optionLabel="label"
        optionValue="value"
        [ngModel]="selectedScope()"
        (ngModelChange)="onScopeFilterChange($event)"
        appendTo="body"
        class="w-18rem"
        placeholder="Scope"
        data-testid="token-scope-filter"
      />
      <p-select
        [options]="usedOptions"
        optionLabel="label"
        optionValue="value"
        [ngModel]="selectedUsed()"
        (ngModelChange)="onUsedFilterChange($event)"
        appendTo="body"
        class="w-12rem"
        placeholder="Used"
        data-testid="token-used-filter"
      />
    </div>

    @if (hasTokens()) {
      <p-table
        [value]="scopedTokens()"
        [rows]="10"
        [paginator]="true"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="{first} to {last} of {totalRecords}"
        [responsiveLayout]="'scroll'"
        data-testid="token-list-table"
      >
        <ng-template #header>
          <tr>
            <th style="width: 5%" pSortableColumn="id">ID <p-sortIcon field="id"></p-sortIcon></th>
            <th style="width: 14%" pSortableColumn="email">
              Email <p-sortIcon field="email"></p-sortIcon>
            </th>
            <th style="width: 12%" pSortableColumn="tenant">
              Tenant <p-sortIcon field="tenant"></p-sortIcon>
            </th>
            <th style="width: 20%" pSortableColumn="token">
              Token <p-sortIcon field="token"></p-sortIcon>
            </th>
            <th style="width: 12%" pSortableColumn="expiresAt">
              Expires at <p-sortIcon field="expiresAt"></p-sortIcon>
            </th>
            <th style="width: 7%" pSortableColumn="used">
              Used <p-sortIcon field="used"></p-sortIcon>
            </th>
            <th style="width: 12%" pSortableColumn="scope">
              Scope <p-sortIcon field="scope"></p-sortIcon>
            </th>
            <th style="width: 12%" pSortableColumn="createdAt">
              Created at <p-sortIcon field="createdAt"></p-sortIcon>
            </th>
            <th style="width: 6%">Actions</th>
          </tr>
        </ng-template>

        <ng-template #body let-row>
          <tr data-testid="token-list-row">
            <td>{{ row.id }}</td>
            <td>{{ row.email }}</td>
            <td>{{ row.tenant || '---' }}</td>
            <td class="break-all">{{ row.token }}</td>
            <td>{{ row.expiresAt | date: 'dd.MM.yyyy HH:mm' }}</td>
            <td>
              <i
                class="pi"
                [ngClass]="{
                  'pi-check-circle text-green-500': row.used,
                  'pi-times-circle text-red-500': !row.used,
                }"
              ></i>
            </td>
            <td>{{ row.scope }}</td>
            <td>{{ row.createdAt | date: 'dd.MM.yyyy HH:mm' }}</td>
            <td>
              <p-button
                icon="pi pi-send"
                severity="secondary"
                [rounded]="true"
                [text]="true"
                [pTooltip]="'selecthorAdmin.scopedTokens.resendInvitationEmail' | transloco"
                tooltipPosition="top"
                [disabled]="row.used || resendingTokenId() === row.id"
                [loading]="resendingTokenId() === row.id"
                (onClick)="confirmResend(row)"
                [attr.data-testid]="'resend-token-' + row.id"
              />
            </td>
          </tr>
        </ng-template>

        <ng-template #emptymessage>
          <tr>
            <td [attr.colspan]="9"><app-no-data /></td>
          </tr>
        </ng-template>
      </p-table>
    } @else {
      <app-no-data />
    }
  }
</app-background-card>
